import { getFormLableStyleStr } from "../FormText/FormBaseStyle";
import { getPaddingString, formFieldErrorHtml, toRGBA } from "../parser/utils";

export default ({ data, id, root }) => {
  const {
    placeholder,
    required,
    label,
  } = data;
  const {
    formBorderWidth,
    formBorderStyle,
    formBorderColor,
    formBorderRadius,
    formTextColor
  } = root.data;
  
  const labelStyle = getFormLableStyleStr(data, root.data);
  return `
    <div class="rip-field-group" style="text-align: left;${getPaddingString(
      data
    )}">
      <label style="${labelStyle}">
      ${
        required
          ? '<span style="color: #ff4d4f; margin-right: 4px;">*</span>'
          : ""
      }${label}
      </label>
      <textarea
        class="rip-form-input"
        style="
          height: 110px; width: 100%; padding: 4px 8px;
          border-width: ${formBorderWidth}px;
          border-style: ${formBorderStyle};
          border-color: ${toRGBA(formBorderColor)};
          border-radius: ${formBorderRadius}px;
          color: ${toRGBA(formTextColor)};
        "
        placeholder="${placeholder}"
        name="${id}"
      ></textarea>
      ${formFieldErrorHtml({ id })}
    </div>
  `;
};
